import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  WalletFirestoreResponse,
  CreateWalletDto,
  UpdateWalletDto,
  DeleteWalletResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const WalletResponseSchema = WalletFirestoreResponse;
export const CreateWalletSchema = CreateWalletDto;
export const UpdateWalletSchema = UpdateWalletDto;
export const DeleteResponseSchema = DeleteWalletResponseDto;

// Type exports
export type WalletResponse = z.infer<typeof WalletFirestoreResponse>;
export type CreateWallet = z.infer<typeof CreateWalletDto>;
export type UpdateWallet = z.infer<typeof UpdateWalletDto>;

// API factory function
export function createWalletsApi(client: TypedApiClient) {
  return {
    getWallets: (): Promise<WalletResponse[]> => {
      return client.get('/wallets', {
        responseSchema: z.array(WalletResponseSchema),
      });
    },

    createWallet: (data: CreateWallet): Promise<WalletResponse> => {
      CreateWalletSchema.parse(data);
      return client.post('/wallets', {
        data,
        responseSchema: WalletResponseSchema,
      });
    },

    updateWallet: (id: string, data: UpdateWallet): Promise<WalletResponse> => {
      return client.patch(apiPath`/wallets/${id}`, {
        data,
        responseSchema: WalletResponseSchema,
      });
    },

    deleteWallet: (id: string): Promise<z.infer<typeof DeleteResponseSchema>> => {
      return client.delete(apiPath`/wallets/${id}`, {
        responseSchema: DeleteResponseSchema,
      });
    },
  };
}
